/**
*!/usr/bin/env node
* -*- coding: utf-8 -*-
* Adewale Joshua Portfolio (AJP)
*/


/**
* author: OTechCup
* copyright: &copy; 2022 - new Date().getFullYear() All Rights Reserved | Exfac
* credits: ["Mr. O"]
* version: v0.1.0
* maintainer: OTechCup
* email: support@exfac.info
*/


// import modules
import React from "react";


function SocialSpace() {
	return (
		<div className="social-links">
			<a href="https://wa.me/+2347053001118" target="_blank"
				rel="noopener noreferrer" className="whatsapp"
			>
				<i className="bi bi-whatsapp"></i>
			</a>

			<a href="https://linkedin.com/in/otechcupp" target="_blank"
				rel="noopener noreferrer" className="linkedin">
				<i className="bi bi-linkedin"></i>
			</a>

			<a href="https://instagram.com/Ch33333f" target="_blank"
				rel="noopener noreferrer" className="instagram"
			>
				<i className="bi bi-instagram"></i>
			</a>

			<a href="https://github.com/Ch333f" target="_blank"
				rel="noopener noreferrer" className="github"
			>
				<i className="bi bi-github"></i>
			</a>

			<a href="https://facebook.com/Ch3333f" target="_blank"
				rel="noopener noreferrer" className="facebook"
			>
				<i className="bi bi-facebook"></i>
			</a>
		</div>
	);
};


export default SocialSpace;
